import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink as ReactRouterLink } from "react-router-dom";

import { CalendarIcon } from "@chakra-ui/icons";
import {
	Button,
	Flex,
	Td,
	Text,
	Tr,
	useColorModeValue,
	ListItem,
	UnorderedList,
	Link,
	Wrap,
	WrapItem,
	Popover,
	PopoverTrigger,
	PopoverHeader,
	PopoverContent,
	PopoverBody,
	VStack,
 Stack, IconButton } from "@chakra-ui/react";
import moment from "moment";
import { AiOutlineAudit } from "react-icons/ai";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { TbContract } from "react-icons/tb";


import { fullDateFormat } from "../../utils/types";
import { getPropertyStatusText } from "../../utils/utils";
import { getPropertyAddress } from "../../utils/verifier";
import OwnerPopover from "../ContactPopover/OwnerPopover";
import TenantPopover from "../ContactPopover/TenantPopover";
import StatusBadge from "../StatusBadge/StatusBadge";
import AdministrationStatusTooltipLabel from "../StatusTooltipLabel/AdministrationStatusTooltipLabel";
import LeaseStatusTooltipLabel from "../StatusTooltipLabel/LeaseStatusTooltipLabel";
import StatementStatusTooltipLabel from "../StatusTooltipLabel/StatementStatusTooltipLabel";


function PropertiesTableRow(props) {
	const { row } = props;
	const textColor = useColorModeValue("gray.700", "white");
	const { t } = useTranslation();

	const admStatus = row.admStatus;
	const leaseStatus = row.leaseStatus;
	const financialStatementStatus = row.financialStatementStatus;
	const bgHover = useColorModeValue("gray.50", "gray.700");

	return (
		<>
			<Tr _hover={{ bg: bgHover }} transition="all 0.2s">
				<Td minWidth={{ sm: "250px" }} pl="0px">
					<VStack align="start" spacing="0">
						<Text fontSize="md" color={textColor} fontWeight="bold">
							{getPropertyAddress(row)}
						</Text>
						<Text fontSize="xs" color="gray.500">
							{moment(row.addedDate).format("DD MMM YYYY - HH:mm")}
						</Text>
					</VStack>
				</Td>
				<Td>
					<OwnerPopover contact={row.owner} />
				</Td>
				{/* <Td textAlign="center">
					<StatusBadge
						status={getPropertyStatusText(admStatus)}
						tooltipLabel={<AdministrationStatusTooltipLabel property={row} administrationStatus={admStatus} />}
					/>
				</Td>
				<Td textAlign="center">
					<StatusBadge status={getPropertyStatusText(leaseStatus)} tooltipLabel={<LeaseStatusTooltipLabel property={row} leaseStatus={leaseStatus} />} />
				</Td>
				<Td textAlign="center">
					<StatusBadge
						status={getPropertyStatusText(financialStatementStatus)}
						tooltipLabel={<StatementStatusTooltipLabel statementStatus={financialStatementStatus} />}
					/>
				</Td> */}
				<Td textAlign="center">
					<Stack direction="row" gap="1">
						<Flex gap="1" flex={1}>
							<MdOutlineAdminPanelSettings size={20} />
							<StatusBadge
								status={getPropertyStatusText(admStatus)}
								tooltipLabel={<AdministrationStatusTooltipLabel property={row} administrationStatus={admStatus} />}
							/>
						</Flex>
						<Flex gap="1" flex={1}>
							<TbContract size={20} />
							<StatusBadge status={getPropertyStatusText(leaseStatus)} tooltipLabel={<LeaseStatusTooltipLabel property={row} leaseStatus={leaseStatus} />} />
						</Flex>
						<Flex gap="1" flex={1}>
							<AiOutlineAudit size={20} />
							<StatusBadge
								status={getPropertyStatusText(financialStatementStatus)}
								tooltipLabel={<StatementStatusTooltipLabel statementStatus={financialStatementStatus} />}
							/>
						</Flex>
					</Stack>
				</Td>
				<Td>
					<Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
						{row.rent.amount} {row.rent.currency}
					</Text>
				</Td>
				<Td>
					<Wrap fontSize="md" color={textColor} pb=".5rem">
						{row.tenants
							?.filter((t) => !t.former)
							.map((t, index) => (
								<WrapItem key={index}>
									<TenantPopover contact={t} propertyId={row.id} />
								</WrapItem>
							))}
					</Wrap>
				</Td>
				<Td>
					<Stack direction="row">
						<Popover>
							<PopoverTrigger>
								<IconButton icon={<CalendarIcon />} size="sm" />
							</PopoverTrigger>
							<PopoverContent>
								<PopoverHeader fontWeight="semibold">{t("table.lastActivities")}</PopoverHeader>
								<PopoverBody>
									{row.activities?.length === 0 && t("table.noData")}
									<UnorderedList whiteSpace={"normal"}>
										{row.activities?.slice(0, 10).map((activity, index) => (
											<ListItem key={index}>
												{activity.title} - {moment(activity.addedDate).format(fullDateFormat)}
											</ListItem>
										))}
									</UnorderedList>
								</PopoverBody>
							</PopoverContent>
						</Popover>

						<Link as={ReactRouterLink} to={`/properties/view/${row.id}`}>
							<Button size="sm">{t("table.view")}</Button>
						</Link>
					</Stack>
				</Td>
			</Tr>
		</>
	);
}

export default PropertiesTableRow;
